// Campos personalizados do lead (issue #306): regras puras do painel de campos em Comercial > Leads e do
// cartão do lead. O backend (api/crm/custom_fields.py) valida de verdade; aqui só montamos o
// payload e formatamos o que ele devolve.

export const FIELD_TYPES = [
  { value: 'text', label: 'Texto' },
  { value: 'number', label: 'Número' },
  { value: 'date', label: 'Data' },
  { value: 'select', label: 'Lista de opções' },
]

export const typeLabel = (type) => FIELD_TYPES.find((t) => t.value === type)?.label || 'Texto'

// Uma opção por linha; remove vazias e repetidas, na ordem digitada.
export function parseOptions(text) {
  const seen = []
  for (const line of String(text || '').split('\n')) {
    const opt = line.trim()
    if (opt && !seen.includes(opt)) seen.push(opt)
  }
  return seen
}

export const optionsToText = (options) => (options || []).join('\n')

// Devolve a mensagem do primeiro problema ou ''.
export function validateFieldForm(form, { editing = false } = {}) {
  if (!String(form.label || '').trim()) return 'Informe o nome do campo.'
  if (form.field_type === 'select' && !parseOptions(form.optionsText).length) {
    return 'A lista precisa de ao menos uma opção.'
  }
  if (!editing && !FIELD_TYPES.some((t) => t.value === form.field_type)) return 'Escolha o tipo do campo.'
  return ''
}

// Corpo do POST (novo) ou do PATCH (editar: chave e tipo não mudam).
export function buildFieldPayload(form, { editing = false } = {}) {
  const payload = { label: form.label.trim() }
  if (!editing) payload.field_type = form.field_type
  if (form.field_type === 'select') payload.options = parseOptions(form.optionsText)
  return payload
}

// Valor guardado -> texto do cartão do lead.
export function formatFieldValue(definition, value) {
  if (value === null || value === undefined || value === '') return ''
  if (definition?.field_type === 'date') {
    const [y, m, d] = String(value).split('-')
    return y && m && d ? `${d}/${m}/${y}` : String(value)
  }
  if (definition?.field_type === 'number') {
    const num = Number(value)
    return Number.isFinite(num) ? num.toLocaleString('pt-BR') : String(value)
  }
  return String(value)
}

// Valor guardado -> valor do <input> de edição (date usa AAAA-MM-DD, igual ao guardado).
export const inputValue = (value) => (value === null || value === undefined ? '' : String(value))

// Só envia o que mudou: { chave: novo valor } (vazio remove o campo).
export function changedValues(definitions, current, draft) {
  const out = {}
  for (const def of definitions) {
    const before = inputValue(current?.[def.key])
    const after = String(draft?.[def.key] ?? '').trim()
    if (before !== after) out[def.key] = after
  }
  return out
}
